// Automatically generated from CSV files. Do not edit directly.
export const MENU_ITEMS = [
  {
    id: 1,
    name: "Veg Burger",
    onlineName: "Veg Burger",
    description:
      "Fresh and tasty Veg Burger made with quality ingredients and delicious flavors.",
    category: "Burger Delights",
    price: 119,
    type: "veg",
    addons: [
      {
        name: "Dips",
        min: 0,
        max: 7,
        selectionType: "M",
        items: [
          {
            name: "Piri Piri Sprinkler",
            price: 20,
            type: "veg",
          },
          {
            name: "Garlic Mayo",
            price: 20,
            type: "egg",
          },
          {
            name: "Tandoori Mayo",
            price: 20,
            type: "veg",
          },
          {
            name: "Peri Peri Mayo",
            price: 20,
            type: "veg",
          },
          {
            name: "Eggless Mayo",
            price: 20,
            type: "veg",
          },
          {
            name: "Spicy Tikka Mayo",
            price: 20,
            type: "veg",
          },
          {
            name: "Cheese",
            price: 20,
            type: "veg",
          },
        ],
      },
    ],
  },
  {
    id: 2,
    name: "Crispy Chicken Burger",
    onlineName: "Crispy Chicken Burger",
    description:
      "Juicy and flavorful Crispy Chicken Burger prepared with rich spices for a satisfying taste.",
    category: "Burger Delights",
    price: 169,
    type: "non-veg",
    addons: [
      {
        name: "Dips",
        min: 0,
        max: 7,
        selectionType: "M",
        items: [
          {
            name: "Piri Piri Sprinkler",
            price: 20,
            type: "veg",
          },
          {
            name: "Garlic Mayo",
            price: 20,
            type: "egg",
          },
          {
            name: "Tandoori Mayo",
            price: 20,
            type: "veg",
          },
          {
            name: "Peri Peri Mayo",
            price: 20,
            type: "veg",
          },
          {
            name: "Eggless Mayo",
            price: 20,
            type: "veg",
          },
          {
            name: "Spicy Tikka Mayo",
            price: 20,
            type: "veg",
          },
          {
            name: "Cheese",
            price: 20,
            type: "veg",
          },
        ],
      },
    ],
  },
  {
    id: 3,
    name: "Royal Chicken Burger",
    onlineName: "Royal Chicken Burger",
    description:
      "Juicy and flavorful Royal Chicken Burger prepared with rich spices for a satisfying taste.",
    category: "Burger Delights",
    price: 249,
    type: "non-veg",
    addons: [
      {
        name: "Dips",
        min: 0,
        max: 7,
        selectionType: "M",
        items: [
          {
            name: "Piri Piri Sprinkler",
            price: 20,
            type: "veg",
          },
          {
            name: "Garlic Mayo",
            price: 20,
            type: "egg",
          },
          {
            name: "Tandoori Mayo",
            price: 20,
            type: "veg",
          },
          {
            name: "Peri Peri Mayo",
            price: 20,
            type: "veg",
          },
          {
            name: "Eggless Mayo",
            price: 20,
            type: "veg",
          },
          {
            name: "Spicy Tikka Mayo",
            price: 20,
            type: "veg",
          },
          {
            name: "Cheese",
            price: 20,
            type: "veg",
          },
        ],
      },
    ],
  },
  {
    id: 4,
    name: "Cheese Loaded Veg Sandwich",
    onlineName: "Cheese Loaded Veg Sandwich",
    description:
      "Fresh and tasty Cheese Loaded Veg Sandwich made with quality ingredients and delicious flavors.",
    category: "Classic Sandwich",
    price: 159,
    type: "veg",
    addons: [
      {
        name: "Dips",
        min: 0,
        max: 7,
        selectionType: "M",
        items: [
          {
            name: "Piri Piri Sprinkler",
            price: 20,
            type: "veg",
          },
          {
            name: "Garlic Mayo",
            price: 20,
            type: "egg",
          },
          {
            name: "Tandoori Mayo",
            price: 20,
            type: "veg",
          },
          {
            name: "Peri Peri Mayo",
            price: 20,
            type: "veg",
          },
          {
            name: "Eggless Mayo",
            price: 20,
            type: "veg",
          },
          {
            name: "Spicy Tikka Mayo",
            price: 20,
            type: "veg",
          },
          {
            name: "Cheese",
            price: 20,
            type: "veg",
          },
        ],
      },
    ],
  },
  {
    id: 5,
    name: "Tandoori Chicken Sandwich",
    onlineName: "Tandoori Chicken Sandwich",
    description:
      "Juicy and flavorful Tandoori Chicken Sandwich prepared with rich spices for a satisfying taste.",
    category: "Classic Sandwich",
    price: 139,
    type: "non-veg",
    addons: [
      {
        name: "Dips",
        min: 0,
        max: 7,
        selectionType: "M",
        items: [
          {
            name: "Piri Piri Sprinkler",
            price: 20,
            type: "veg",
          },
          {
            name: "Garlic Mayo",
            price: 20,
            type: "egg",
          },
          {
            name: "Tandoori Mayo",
            price: 20,
            type: "veg",
          },
          {
            name: "Peri Peri Mayo",
            price: 20,
            type: "veg",
          },
          {
            name: "Eggless Mayo",
            price: 20,
            type: "veg",
          },
          {
            name: "Spicy Tikka Mayo",
            price: 20,
            type: "veg",
          },
          {
            name: "Cheese",
            price: 20,
            type: "veg",
          },
        ],
      },
    ],
  },
  {
    id: 6,
    name: "Cheese Loaded Chicken Sandwich",
    onlineName: "Cheese Loaded Chicken Sandwich",
    description:
      "Juicy and flavorful Cheese Loaded Chicken Sandwich prepared with rich spices for a satisfying taste.",
    category: "Classic Sandwich",
    price: 179,
    type: "non-veg",
    addons: [
      {
        name: "Dips",
        min: 0,
        max: 7,
        selectionType: "M",
        items: [
          {
            name: "Piri Piri Sprinkler",
            price: 20,
            type: "veg",
          },
          {
            name: "Garlic Mayo",
            price: 20,
            type: "egg",
          },
          {
            name: "Tandoori Mayo",
            price: 20,
            type: "veg",
          },
          {
            name: "Peri Peri Mayo",
            price: 20,
            type: "veg",
          },
          {
            name: "Eggless Mayo",
            price: 20,
            type: "veg",
          },
          {
            name: "Spicy Tikka Mayo",
            price: 20,
            type: "veg",
          },
          {
            name: "Cheese",
            price: 20,
            type: "veg",
          },
        ],
      },
      {
        name: "Choice Of Dietary",
        min: 1,
        max: 1,
        selectionType: "S",
        items: [
          {
            name: "Veg",
            price: 0,
            type: "veg",
          },
          {
            name: "Non-veg",
            price: 10,
            type: "non-veg",
          },
        ],
      },
    ],
  },
  {
    id: 7,
    name: "Bucket  flakesfriedchicken",
    onlineName: "Bucket  flakesfriedchicken",
    description:
      "Delicious Bucket  flakesfriedchicken made with premium ingredients and authentic taste.",
    category: "All in One flakesfriedchickens",
    price: 649,
    type: "non-veg",
    addons: [
      {
        name: "Add On",
        min: 0,
        max: 4,
        selectionType: "M",
        items: [
          {
            name: "Chicken Wrap",
            price: 99,
            type: "non-veg",
          },
          {
            name: "Chicken Burger",
            price: 109,
            type: "non-veg",
          },
          {
            name: "Mojito",
            price: 69,
            type: "veg",
          },
          {
            name: "Momo",
            price: 99,
            type: "non-veg",
          },
        ],
      },
      {
        name: "Dips",
        min: 0,
        max: 7,
        selectionType: "M",
        items: [
          {
            name: "Piri Piri Sprinkler",
            price: 20,
            type: "veg",
          },
          {
            name: "Garlic Mayo",
            price: 20,
            type: "egg",
          },
          {
            name: "Tandoori Mayo",
            price: 20,
            type: "veg",
          },
          {
            name: "Peri Peri Mayo",
            price: 20,
            type: "veg",
          },
          {
            name: "Eggless Mayo",
            price: 20,
            type: "veg",
          },
          {
            name: "Spicy Tikka Mayo",
            price: 20,
            type: "veg",
          },
          {
            name: "Cheese",
            price: 20,
            type: "veg",
          },
        ],
      },
    ],
  },
  {
    id: 8,
    name: "Friends flakesfriedchicken",
    onlineName: "Friends flakesfriedchicken",
    description:
      "Delicious Friends flakesfriedchicken made with premium ingredients and authentic taste.",
    category: "All in One flakesfriedchickens",
    price: 699,
    type: "non-veg",
    addons: [
      {
        name: "Add On",
        min: 0,
        max: 4,
        selectionType: "M",
        items: [
          {
            name: "Chicken Wrap",
            price: 99,
            type: "non-veg",
          },
          {
            name: "Chicken Burger",
            price: 109,
            type: "non-veg",
          },
          {
            name: "Mojito",
            price: 69,
            type: "veg",
          },
          {
            name: "Momo",
            price: 99,
            type: "non-veg",
          },
        ],
      },
      {
        name: "Dips",
        min: 0,
        max: 7,
        selectionType: "M",
        items: [
          {
            name: "Piri Piri Sprinkler",
            price: 20,
            type: "veg",
          },
          {
            name: "Garlic Mayo",
            price: 20,
            type: "egg",
          },
          {
            name: "Tandoori Mayo",
            price: 20,
            type: "veg",
          },
          {
            name: "Peri Peri Mayo",
            price: 20,
            type: "veg",
          },
          {
            name: "Eggless Mayo",
            price: 20,
            type: "veg",
          },
          {
            name: "Spicy Tikka Mayo",
            price: 20,
            type: "veg",
          },
          {
            name: "Cheese",
            price: 20,
            type: "veg",
          },
        ],
      },
    ],
  },
  {
    id: 9,
    name: "Family flakesfriedchicken",
    onlineName: "Family flakesfriedchicken",
    description:
      "Delicious Family flakesfriedchicken made with premium ingredients and authentic taste.",
    category: "All in One flakesfriedchickens",
    price: 799,
    type: "non-veg",
    addons: [],
  },
  {
    id: 10,
    name: "Hot Gulab Jamun With Ice Cream",
    onlineName: "Hot Gulab Jamun With Ice Cream",
    description:
      "Delicious Hot Gulab Jamun With Ice Cream made with premium ingredients and authentic taste.",
    category: "Desserts",
    price: 119,
    type: "veg",
    addons: [],
  },
  {
    id: 11,
    name: "Brownie With Ice Cream",
    onlineName: "Brownie With Ice Cream",
    description:
      "Delicious Brownie With Ice Cream made with premium ingredients and authentic taste.",
    category: "Desserts",
    price: 119,
    type: "veg",
    addons: [],
  },
  {
    id: 12,
    name: "Mauna Loa Cake",
    onlineName: "Mauna Loa Cake",
    description:
      "Delicious Mauna Loa Cake made with premium ingredients and authentic taste.",
    category: "Desserts",
    price: 79,
    type: "veg",
    addons: [],
  },
  {
    id: 13,
    name: "Falooda",
    onlineName: "Falooda",
    description:
      "Delicious Falooda made with premium ingredients and authentic taste.",
    category: "Desserts",
    price: 149,
    type: "veg",
    addons: [],
  },
  {
    id: 14,
    name: "Crispy Burger Meal",
    onlineName: "Crispy Burger Meal",
    description:
      "Tasty Crispy Burger Meal served in a soft bun with fresh fillings and sauces.",
    category: "Meal Box",
    price: 249,
    type: "non-veg",
    addons: [
      {
        name: "Dips",
        min: 0,
        max: 7,
        selectionType: "M",
        items: [
          {
            name: "Piri Piri Sprinkler",
            price: 20,
            type: "veg",
          },
          {
            name: "Garlic Mayo",
            price: 20,
            type: "egg",
          },
          {
            name: "Tandoori Mayo",
            price: 20,
            type: "veg",
          },
          {
            name: "Peri Peri Mayo",
            price: 20,
            type: "veg",
          },
          {
            name: "Eggless Mayo",
            price: 20,
            type: "veg",
          },
          {
            name: "Spicy Tikka Mayo",
            price: 20,
            type: "veg",
          },
          {
            name: "Cheese",
            price: 20,
            type: "veg",
          },
        ],
      },
    ],
  },
  {
    id: 15,
    name: "Vanilla Milk Shake",
    onlineName: "Vanilla Milk Shake",
    description:
      "Delicious Vanilla Milk Shake made with premium ingredients and authentic taste.",
    category: "Milk Shakes",
    price: 109,
    type: "veg",
    addons: [],
  },
  {
    id: 16,
    name: "Straberry Milk Shake",
    onlineName: "Straberry Milk Shake",
    description:
      "Delicious Straberry Milk Shake made with premium ingredients and authentic taste.",
    category: "Milk Shakes",
    price: 109,
    type: "veg",
    addons: [],
  },
  {
    id: 17,
    name: "Choco Forest Milk Shake",
    onlineName: "Choco Forest Milk Shake",
    description:
      "Delicious Choco Forest Milk Shake made with premium ingredients and authentic taste.",
    category: "Milk Shakes",
    price: 129,
    type: "veg",
    addons: [],
  },
  {
    id: 18,
    name: "Black Currant Milk Shake",
    onlineName: "Black Currant Milk Shake",
    description:
      "Delicious Black Currant Milk Shake made with premium ingredients and authentic taste.",
    category: "Milk Shakes",
    price: 139,
    type: "veg",
    addons: [],
  },
  {
    id: 19,
    name: "Oreo Crush Milk Shake",
    onlineName: "Oreo Crush Milk Shake",
    description:
      "Delicious Oreo Crush Milk Shake made with premium ingredients and authentic taste.",
    category: "Milk Shakes",
    price: 129,
    type: "veg",
    addons: [],
  },
  {
    id: 20,
    name: "Chicken Popcorn",
    onlineName: "Chicken Popcorn",
    description:
      "Juicy and flavorful Chicken Popcorn prepared with rich spices for a satisfying taste.",
    category: "Snackers",
    price: 115,
    type: "non-veg",
    addons: [
      {
        name: "Dips",
        min: 0,
        max: 7,
        selectionType: "M",
        items: [
          {
            name: "Piri Piri Sprinkler",
            price: 20,
            type: "veg",
          },
          {
            name: "Garlic Mayo",
            price: 20,
            type: "egg",
          },
          {
            name: "Tandoori Mayo",
            price: 20,
            type: "veg",
          },
          {
            name: "Peri Peri Mayo",
            price: 20,
            type: "veg",
          },
          {
            name: "Eggless Mayo",
            price: 20,
            type: "veg",
          },
          {
            name: "Spicy Tikka Mayo",
            price: 20,
            type: "veg",
          },
          {
            name: "Cheese",
            price: 20,
            type: "veg",
          },
        ],
      },
    ],
  },
  {
    id: 21,
    name: "Crunchy Lollypop 4 Pcs",
    onlineName: "Crunchy Lollypop 4 Pcs",
    description:
      "Delicious Crunchy Lollypop 4 Pcs made with premium ingredients and authentic taste.",
    category: "Snackers",
    price: 189,
    type: "non-veg",
    addons: [
      {
        name: "Dips",
        min: 0,
        max: 7,
        selectionType: "M",
        items: [
          {
            name: "Piri Piri Sprinkler",
            price: 20,
            type: "veg",
          },
          {
            name: "Garlic Mayo",
            price: 20,
            type: "egg",
          },
          {
            name: "Tandoori Mayo",
            price: 20,
            type: "veg",
          },
          {
            name: "Peri Peri Mayo",
            price: 20,
            type: "veg",
          },
          {
            name: "Eggless Mayo",
            price: 20,
            type: "veg",
          },
          {
            name: "Spicy Tikka Mayo",
            price: 20,
            type: "veg",
          },
          {
            name: "Cheese",
            price: 20,
            type: "veg",
          },
        ],
      },
    ],
  },
  {
    id: 22,
    name: "Crispy Wings 6 Pcs",
    onlineName: "Crispy Wings 6 Pcs",
    description:
      "Delicious Crispy Wings 6 Pcs made with premium ingredients and authentic taste.",
    category: "Snackers",
    price: 199,
    type: "non-veg",
    addons: [
      {
        name: "Dips",
        min: 0,
        max: 7,
        selectionType: "M",
        items: [
          {
            name: "Piri Piri Sprinkler",
            price: 20,
            type: "veg",
          },
          {
            name: "Garlic Mayo",
            price: 20,
            type: "egg",
          },
          {
            name: "Tandoori Mayo",
            price: 20,
            type: "veg",
          },
          {
            name: "Peri Peri Mayo",
            price: 20,
            type: "veg",
          },
          {
            name: "Eggless Mayo",
            price: 20,
            type: "veg",
          },
          {
            name: "Spicy Tikka Mayo",
            price: 20,
            type: "veg",
          },
          {
            name: "Cheese",
            price: 20,
            type: "veg",
          },
        ],
      },
    ],
  },
  {
    id: 23,
    name: "Boneless Strips 3 Pcs",
    onlineName: "Boneless Strips 3 Pcs",
    description:
      "Delicious Boneless Strips 3 Pcs made with premium ingredients and authentic taste.",
    category: "Snackers",
    price: 139,
    type: "non-veg",
    addons: [
      {
        name: "Dips",
        min: 0,
        max: 7,
        selectionType: "M",
        items: [
          {
            name: "Piri Piri Sprinkler",
            price: 20,
            type: "veg",
          },
          {
            name: "Garlic Mayo",
            price: 20,
            type: "egg",
          },
          {
            name: "Tandoori Mayo",
            price: 20,
            type: "veg",
          },
          {
            name: "Peri Peri Mayo",
            price: 20,
            type: "veg",
          },
          {
            name: "Eggless Mayo",
            price: 20,
            type: "veg",
          },
          {
            name: "Spicy Tikka Mayo",
            price: 20,
            type: "veg",
          },
          {
            name: "Cheese",
            price: 20,
            type: "veg",
          },
        ],
      },
    ],
  },
  {
    id: 24,
    name: "Piri Piri Fries",
    onlineName: "Piri Piri Fries",
    description:
      "Delicious Piri Piri Fries made with premium ingredients and authentic taste.",
    category: "Mini Bites",
    price: 95,
    type: "veg",
    addons: [
      {
        name: "Dips",
        min: 0,
        max: 7,
        selectionType: "M",
        items: [
          {
            name: "Piri Piri Sprinkler",
            price: 20,
            type: "veg",
          },
          {
            name: "Garlic Mayo",
            price: 20,
            type: "egg",
          },
          {
            name: "Tandoori Mayo",
            price: 20,
            type: "veg",
          },
          {
            name: "Peri Peri Mayo",
            price: 20,
            type: "veg",
          },
          {
            name: "Eggless Mayo",
            price: 20,
            type: "veg",
          },
          {
            name: "Spicy Tikka Mayo",
            price: 20,
            type: "veg",
          },
          {
            name: "Cheese",
            price: 20,
            type: "veg",
          },
        ],
      },
    ],
  },
  {
    id: 25,
    name: "French Fries",
    onlineName: "French Fries",
    description:
      "Delicious French Fries made with premium ingredients and authentic taste.",
    category: "Mini Bites",
    price: 79,
    type: "veg",
    addons: [
      {
        name: "Dips",
        min: 0,
        max: 7,
        selectionType: "M",
        items: [
          {
            name: "Piri Piri Sprinkler",
            price: 20,
            type: "veg",
          },
          {
            name: "Garlic Mayo",
            price: 20,
            type: "egg",
          },
          {
            name: "Tandoori Mayo",
            price: 20,
            type: "veg",
          },
          {
            name: "Peri Peri Mayo",
            price: 20,
            type: "veg",
          },
          {
            name: "Eggless Mayo",
            price: 20,
            type: "veg",
          },
          {
            name: "Spicy Tikka Mayo",
            price: 20,
            type: "veg",
          },
          {
            name: "Cheese",
            price: 20,
            type: "veg",
          },
        ],
      },
    ],
  },
  {
    id: 26,
    name: "Mint Mojito",
    onlineName: "Mint Mojito",
    description:
      "Delicious Mint Mojito made with premium ingredients and authentic taste.",
    category: "Mojitos",
    price: 89,
    type: "veg",
    addons: [],
  },
  {
    id: 27,
    name: "Virgin Blue Mojito",
    onlineName: "Virgin Blue Mojito",
    description:
      "Delicious Virgin Blue Mojito made with premium ingredients and authentic taste.",
    category: "Mojitos",
    price: 89,
    type: "veg",
    addons: [],
  },
  {
    id: 28,
    name: "Green Apple Mojito",
    onlineName: "Green Apple Mojito",
    description:
      "Delicious Green Apple Mojito made with premium ingredients and authentic taste.",
    category: "Mojitos",
    price: 89,
    type: "veg",
    addons: [],
  },
  {
    id: 29,
    name: "Tandoori Mayo",
    onlineName: "Tandoori Mayo",
    description:
      "Delicious Tandoori Mayo made with premium ingredients and authentic taste.",
    category: "Mayo / Sprinkler",
    price: 20,
    type: "veg",
    addons: [],
  },
  {
    id: 30,
    name: "Eggless Mayo",
    onlineName: "Eggless Mayo",
    description:
      "Delicious Eggless Mayo made with premium ingredients and authentic taste.",
    category: "Mayo / Sprinkler",
    price: 20,
    type: "veg",
    addons: [],
  },
  {
    id: 31,
    name: "Spicy Tikka Mayo",
    onlineName: "Spicy Tikka Mayo",
    description:
      "Delicious Spicy Tikka Mayo made with premium ingredients and authentic taste.",
    category: "Mayo / Sprinkler",
    price: 20,
    type: "veg",
    addons: [],
  },
  {
    id: 32,
    name: "Cheese",
    onlineName: "Cheese",
    description:
      "Delicious Cheese loaded with creamy melted cheese for a rich bite.",
    category: "Mayo / Sprinkler",
    price: 20,
    type: "veg",
    addons: [],
  },
  {
    id: 33,
    name: "Peri Peri Sprinkler",
    onlineName: "Peri Peri Sprinkler",
    description:
      "Delicious Peri Peri Sprinkler made with premium ingredients and authentic taste.",
    category: "Mayo / Sprinkler",
    price: 15,
    type: "veg",
    addons: [],
  },
  {
    id: 34,
    name: "Vanilla Ice Cream",
    onlineName: "Vanilla Ice Cream",
    description:
      "Delicious Vanilla Ice Cream made with premium ingredients and authentic taste.",
    category: "Scoop Ice Cream",
    price: 69,
    type: "veg",
    addons: [],
  },
  {
    id: 35,
    name: "Strawberry Ice Cream",
    onlineName: "Strawberry Ice Cream",
    description:
      "Delicious Strawberry Ice Cream made with premium ingredients and authentic taste.",
    category: "Scoop Ice Cream",
    price: 69,
    type: "veg",
    addons: [],
  },
  {
    id: 36,
    name: "Chocolate Ice Cream",
    onlineName: "Chocolate Ice Cream",
    description:
      "Delicious Chocolate Ice Cream made with premium ingredients and authentic taste.",
    category: "Scoop Ice Cream",
    price: 79,
    type: "veg",
    addons: [],
  },
  {
    id: 37,
    name: "Black Currant Ice Cream",
    onlineName: "Black Currant Ice Cream",
    description:
      "Delicious Black Currant Ice Cream made with premium ingredients and authentic taste.",
    category: "Scoop Ice Cream",
    price: 89,
    type: "veg",
    addons: [],
  },
  {
    id: 38,
    name: "Spl Falooda",
    onlineName: "SPL Falooda",
    description:
      "Delicious Spl Falooda made with premium ingredients and authentic taste.",
    category: "Desserts",
    price: 189,
    type: "veg",
    addons: [],
  },
  {
    id: 39,
    name: "Piri Piri Mayo",
    onlineName: "Piri Piri Mayo",
    description:
      "Delicious Piri Piri Mayo made with premium ingredients and authentic taste.",
    category: "Mayo / Sprinkler",
    price: 20,
    type: "veg",
    addons: [],
  },
  {
    id: 40,
    name: "Garlic Mayo",
    onlineName: "Garlic Mayo",
    description:
      "Delicious Garlic Mayo made with premium ingredients and authentic taste.",
    category: "Mayo / Sprinkler",
    price: 20,
    type: "veg",
    addons: [],
  },
  {
    id: 41,
    name: "Crispy Chicken Meal",
    onlineName: "Crispy Chicken Meal",
    description:
      "Juicy and flavorful Crispy Chicken Meal prepared with rich spices for a satisfying taste.",
    category: "Meal Box",
    price: 219,
    type: "non-veg",
    addons: [
      {
        name: "Dips",
        min: 0,
        max: 7,
        selectionType: "M",
        items: [
          {
            name: "Piri Piri Sprinkler",
            price: 20,
            type: "veg",
          },
          {
            name: "Garlic Mayo",
            price: 20,
            type: "egg",
          },
          {
            name: "Tandoori Mayo",
            price: 20,
            type: "veg",
          },
          {
            name: "Peri Peri Mayo",
            price: 20,
            type: "veg",
          },
          {
            name: "Eggless Mayo",
            price: 20,
            type: "veg",
          },
          {
            name: "Spicy Tikka Mayo",
            price: 20,
            type: "veg",
          },
          {
            name: "Cheese",
            price: 20,
            type: "veg",
          },
        ],
      },
    ],
  },
  {
    id: 42,
    name: "1 Lit Wter Bottle",
    onlineName: "1 Lit Wter Bottle",
    description: "",
    category: "Add-On",
    price: 18,
    type: "veg",
    addons: [],
  },
  {
    id: 43,
    name: "250 ML SPRITE",
    onlineName: "250 ML SPRITE",
    description: "",
    category: "Add-On",
    price: 20,
    type: "veg",
    addons: [],
  },
  {
    id: 44,
    name: "250 ML COKE",
    onlineName: "250 ML COKE",
    description: "",
    category: "Add-On",
    price: 20,
    type: "veg",
    addons: [],
  },
  {
    id: 45,
    name: "250 ML 7 UP",
    onlineName: "250 ML 7 UP",
    description: "",
    category: "Add-On",
    price: 20,
    type: "veg",
    addons: [],
  },
  {
    id: 46,
    name: "250 ML PEPSI",
    onlineName: "250 ML PEPSI",
    description: "",
    category: "Add-On",
    price: 20,
    type: "veg",
    addons: [],
  },
  {
    id: 47,
    name: "250 ML SODA",
    onlineName: "250 ML SODA",
    description: "",
    category: "Add-On",
    price: 12,
    type: "veg",
    addons: [],
  },
  {
    id: 48,
    name: "750 ML SODA",
    onlineName: "750 ML SODA",
    description: "",
    category: "Add-On",
    price: 20,
    type: "veg",
    addons: [],
  },
  {
    id: 49,
    name: "600 Ml Coke",
    onlineName: "600 Ml Coke",
    description: "",
    category: "Add-On",
    price: 40,
    type: "veg",
    addons: [],
  },
  {
    id: 50,
    name: "600 Ml Pepsi",
    onlineName: "600 Ml Pepsi",
    description: "",
    category: "Add-On",
    price: 40,
    type: "veg",
    addons: [],
  },
  {
    id: 51,
    name: "600 Ml 7up",
    onlineName: "600 Ml 7up",
    description: "",
    category: "Add-On",
    price: 40,
    type: "veg",
    addons: [],
  },
  {
    id: 52,
    name: "600 Ml Sprit",
    onlineName: "600 Ml Sprit",
    description: "",
    category: "Add-On",
    price: 40,
    type: "veg",
    addons: [],
  },
  {
    id: 53,
    name: "Plum Cake (500gm)",
    onlineName: "Plum Cake ( 500gm )",
    description:
      "Delicious Plum Cake (500gm) made with premium ingredients and authentic taste.",
    category: "Desserts",
    price: 250,
    type: "veg",
    addons: [],
  },
  {
    id: 54,
    name: "Korean Chicken 1pcs",
    onlineName: "Korean Chicken 1pcs",
    description:
      "Juicy and flavorful Korean Chicken 1pcs prepared with rich spices for a satisfying taste.",
    category: "Snackers",
    price: 109,
    type: "non-veg",
    addons: [],
  },
  {
    id: 55,
    name: "Chessy Popcorn",
    onlineName: "Chessy Popcorn",
    description:
      "Delicious Chessy Popcorn made with premium ingredients and authentic taste.",
    category: "Snackers",
    price: 159,
    type: "non-veg",
    addons: [],
  },
  {
    id: 56,
    name: "Hot N Crispy Strips 3pcs",
    onlineName: "Hot N Crispy Strips 3pcs",
    description:
      "Delicious Hot N Crispy Strips 3pcs made with premium ingredients and authentic taste.",
    category: "Snackers",
    price: 159,
    type: "non-veg",
    addons: [],
  },
  {
    id: 57,
    name: "Chessy French Fries",
    onlineName: "Chessy French Fries",
    description:
      "Delicious Chessy French Fries made with premium ingredients and authentic taste.",
    category: "Mini Bites",
    price: 109,
    type: "veg",
    addons: [],
  },
  {
    id: 58,
    name: "Chicken Loaded Fries",
    onlineName: "Chicken Loaded Fries",
    description:
      "Juicy and flavorful Chicken Loaded Fries prepared with rich spices for a satisfying taste.",
    category: "Mini Bites",
    price: 199,
    type: "non-veg",
    addons: [],
  },
  {
    id: 59,
    name: "Double Loaded Cheese Veggie Burger",
    onlineName: "Double Loaded Cheese Veggie Burger",
    description:
      "Fresh and tasty Double Loaded Cheese Veggie Burger made with quality ingredients and delicious flavors.",
    category: "Burger Delights",
    price: 149,
    type: "veg",
    addons: [],
  },
  {
    id: 60,
    name: "Cheese Chicken Burger",
    onlineName: "Cheese Chicken Burger",
    description:
      "Juicy and flavorful Cheese Chicken Burger prepared with rich spices for a satisfying taste.",
    category: "Burger Delights",
    price: 199,
    type: "non-veg",
    addons: [],
  },
  {
    id: 61,
    name: "Classic Tandoori Burger With Cheese",
    onlineName: "Classic Tandoori Burger With Cheese",
    description:
      "Delicious Classic Tandoori Burger With Cheese loaded with creamy melted cheese for a rich bite.",
    category: "Burger Delights",
    price: 219,
    type: "non-veg",
    addons: [],
  },
  {
    id: 62,
    name: "Grill Chicken Burger",
    onlineName: "Grill Chicken Burger",
    description:
      "Juicy and flavorful Grill Chicken Burger prepared with rich spices for a satisfying taste.",
    category: "Burger Delights",
    price: 219,
    type: "non-veg",
    addons: [],
  },
  {
    id: 63,
    name: "Classic Chicken Roll",
    onlineName: "Classic Chicken Roll",
    description:
      "Juicy and flavorful Classic Chicken Roll prepared with rich spices for a satisfying taste.",
    category: "Classic Indian Roll",
    price: 109,
    type: "non-veg",
    addons: [],
  },
  {
    id: 64,
    name: "Cheesy Chicken Roll",
    onlineName: "Cheesy Chicken Roll",
    description:
      "Juicy and flavorful Cheesy Chicken Roll prepared with rich spices for a satisfying taste.",
    category: "Classic Indian Roll",
    price: 149,
    type: "non-veg",
    addons: [],
  },
  {
    id: 65,
    name: "Tandoori Chicken Roll",
    onlineName: "Tandoori Chicken Roll",
    description:
      "Juicy and flavorful Tandoori Chicken Roll prepared with rich spices for a satisfying taste.",
    category: "Classic Indian Roll",
    price: 149,
    type: "non-veg",
    addons: [],
  },
  {
    id: 66,
    name: "Korean Chicken Roll",
    onlineName: "Korean Chicken Roll",
    description:
      "Juicy and flavorful Korean Chicken Roll prepared with rich spices for a satisfying taste.",
    category: "Classic Indian Roll",
    price: 149,
    type: "non-veg",
    addons: [],
  },
  {
    id: 67,
    name: "Popcorn Chicken Roll",
    onlineName: "Popcorn Chicken Roll",
    description:
      "Juicy and flavorful Popcorn Chicken Roll prepared with rich spices for a satisfying taste.",
    category: "Meal Box",
    price: 249,
    type: "non-veg",
    addons: [],
  },
  {
    id: 68,
    name: "Students Meal",
    onlineName: "Students Meal",
    description:
      "Delicious Students Meal made with premium ingredients and authentic taste.",
    category: "Meal Box",
    price: 599,
    type: "non-veg",
    addons: [],
  },
  {
    id: 69,
    name: "Fried Chicken 1pcs",
    onlineName: "Fried Chicken 1pcs",
    description:
      "Juicy and flavorful Fried Chicken 1pcs prepared with rich spices for a satisfying taste.",
    category: "Fried Chicken",
    price: 99,
    type: "non-veg",
    addons: [],
  },
  {
    id: 70,
    name: "Fried Chicken 2pcs",
    onlineName: "Fried Chicken 2pcs",
    description:
      "Juicy and flavorful Fried Chicken 2pcs prepared with rich spices for a satisfying taste.",
    category: "Fried Chicken",
    price: 195,
    type: "non-veg",
    addons: [],
  },
  {
    id: 71,
    name: "Fried Chicken 4pcs",
    onlineName: "Fried Chicken 4pcs",
    description:
      "Juicy and flavorful Fried Chicken 4pcs prepared with rich spices for a satisfying taste.",
    category: "Fried Chicken",
    price: 389,
    type: "non-veg",
    addons: [],
  },
  {
    id: 72,
    name: "Fried Chicken 6pcs",
    onlineName: "Fried Chicken 6pcs",
    description:
      "Juicy and flavorful Fried Chicken 6pcs prepared with rich spices for a satisfying taste.",
    category: "Fried Chicken",
    price: 579,
    type: "non-veg",
    addons: [],
  },
  {
    id: 73,
    name: "Chciken Momos",
    onlineName: "Chciken Momos",
    description:
      "Delicious Chciken Momos made with premium ingredients and authentic taste.",
    category: "Mini Bites",
    price: 119,
    type: "non-veg",
    addons: [],
  },
  {
    id: 74,
    name: "Veg Momos",
    onlineName: "Veg Momos",
    description:
      "Fresh and tasty Veg Momos made with quality ingredients and delicious flavors.",
    category: "Mini Bites",
    price: 109,
    type: "veg",
    addons: [],
  },
  {
    id: 75,
    name: "Corn Momos",
    onlineName: "Corn Momos",
    description:
      "Delicious Corn Momos made with premium ingredients and authentic taste.",
    category: "Mini Bites",
    price: 129,
    type: "veg",
    addons: [],
  },
  {
    id: 76,
    name: "Veg Strips",
    onlineName: "Veg Strips",
    description:
      "Fresh and tasty Veg Strips made with quality ingredients and delicious flavors.",
    category: "Mini Bites",
    price: 109,
    type: "veg",
    addons: [],
  },
  {
    id: 77,
    name: "Newyear Value Crispy Bucket flakesfriedchicken",
    onlineName: "Newyear Value Crispy Bucket flakesfriedchicken",
    description:
      "Delicious Newyear Value Crispy Bucket flakesfriedchicken made with premium ingredients and authentic taste.",
    category: "New Year Special flakesfriedchicken",
    price: 899,
    type: "non-veg",
    addons: [],
  },
  {
    id: 78,
    name: "Newyear Value Crispy Sandwich flakesfriedchicken",
    onlineName: "Newyear Value Crispy Sandwich flakesfriedchicken",
    description:
      "Grilled Newyear Value Crispy Sandwich flakesfriedchicken packed with flavorful fillings and served fresh.",
    category: "New Year Special flakesfriedchicken",
    price: 399,
    type: "non-veg",
    addons: [],
  },
  {
    id: 79,
    name: "Chicken Drum Stick 2pcs",
    onlineName: "Chicken Drum Stick 2pcs",
    description:
      "Juicy and flavorful Chicken Drum Stick 2pcs prepared with rich spices for a satisfying taste.",
    category: "Chicken Drumstick",
    price: 189,
    type: "non-veg",
    addons: [],
  },
  {
    id: 80,
    name: "Chicken Drum Stick 4pcs",
    onlineName: "Chicken Drum Stick 4pcs",
    description:
      "Juicy and flavorful Chicken Drum Stick 4pcs prepared with rich spices for a satisfying taste.",
    category: "Chicken Drumstick",
    price: 379,
    type: "non-veg",
    addons: [],
  },
  {
    id: 81,
    name: "Chicken Drum Stick 6pcs",
    onlineName: "Chicken Drum Stick 6pcs",
    description:
      "Juicy and flavorful Chicken Drum Stick 6pcs prepared with rich spices for a satisfying taste.",
    category: "Chicken Drumstick",
    price: 569,
    type: "non-veg",
    addons: [],
  },
  {
    id: 82,
    name: "Single flakesfriedchicken",
    onlineName: "Single flakesfriedchicken",
    description:
      "Fried Chicken (1 Pcs)+Burger or Sandwich (1 Pcs)+Coke (1 Nos)+ Dip(1 Nos)",
    category: "IPL flakesfriedchickens",
    price: 209,
    type: "veg",
    addons: [],
  },
  {
    id: 83,
    name: "4 Person flakesfriedchicken",
    onlineName: "4 Person flakesfriedchicken",
    description:
      "Frired Chicken (4 Pcs)+Piri Piri Wings (4 Pcs)+Crispy Burger (2 Pcs)+Fries (2 Nos)+Coke (2 Nos)+Dip (4 Nos)",
    category: "IPL flakesfriedchickens",
    price: 749,
    type: "veg",
    addons: [],
  },
  {
    id: 84,
    name: "Ffc flakesfriedchicken - 01",
    onlineName: "FFC flakesfriedchicken - 01",
    description:
      "Fried Chicken-2 pcs + Crispy Wings-4 pcs + Boneless Strips-4 pcs + Dip-4 nos",
    category: "Flakes Friday Feast",
    price: 399,
    type: "non-veg",
    addons: [],
  },
  {
    id: 85,
    name: "Ffc flakesfriedchicken - 02",
    onlineName: "FFC flakesfriedchicken - 02",
    description: "Boneless Strips-12 pcs + Dip-4 pcs",
    category: "Flakes Friday Feast",
    price: 369,
    type: "non-veg",
    addons: [],
  },
  {
    id: 86,
    name: "Ffc flakesfriedchicken - 03",
    onlineName: "FFC flakesfriedchicken - 03",
    description: "Fried Chicke-10 pcs + Dip-4 pcs",
    category: "Flakes Friday Feast",
    price: 681,
    type: "non-veg",
    addons: [],
  },
];
